import { useState } from "react";
import { imgUrl } from "@/lib/api";
import { PRODUCT } from "@/constants/testIds";

export const ProductGallery = ({ product }) => {
  const photos = [product.image, ...(product.gallery || [])];
  const [i, setI] = useState(0);
  const current = photos[Math.min(i, photos.length - 1)];
  return (
    <div>
      <img data-testid={PRODUCT.mainImage} src={imgUrl(current)} alt={i === 0 ? product.name : `${product.name}, photo ${i + 1}`} className="w-full aspect-square object-cover rounded-[2rem] bg-[#F0EBE1]" />
      {photos.length > 1 && (
        <div className="mt-3 flex gap-2 overflow-x-auto">
          {photos.map((src, j) => (
            <button
              key={`${src}-${j}`}
              data-testid={PRODUCT.thumb(j)}
              onClick={() => setI(j)}
              aria-label={`Show photo ${j + 1}`}
              aria-pressed={j === i}
              className={`shrink-0 w-16 h-16 rounded-xl overflow-hidden border-2 transition-colors ${j === i ? "border-[#E06D44]" : "border-transparent"}`}
            >
              <img src={imgUrl(src)} alt={`${product.name}, photo ${j + 1}`} loading="lazy" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
